import { graphql } from '~/gql'

const SINGLE_DEAL_QUERY = graphql(`
  query singleDeal($productIds: [ID]) {
    dealsEmail(productIds: $productIds) {
      deals {
        ...dealFields
      }
    }
  }
`)

export default SINGLE_DEAL_QUERY
